const initialState = {
	open: false,
	quickAddedServiceProvider: false
}

const actionTypes = {
    OPEN_REPORT_VIEWER_DIALOG: "OPEN_REPORT_VIEWER_DIALOG",
    CLOSE_REPORT_VIEWER_DIALOG: "CLOSE_REPORT_VIEWER_DIALOG",
	QUICK_ADDED_SERVICE_PROVIDER: "QUICK_ADDED_SERVICE_PROVIDER"
}

export function openReportViewerDialog(){
    return {
        type: actionTypes.OPEN_REPORT_VIEWER_DIALOG,
    }
}

export function closeReportViewerDialog(){
    return {
        type: actionTypes.CLOSE_REPORT_VIEWER_DIALOG,
    }
}


export function quickAddServiceProvider() {
	return {
		type: actionTypes.QUICK_ADDED_SERVICE_PROVIDER,
	}
}

export default function (state = initialState, action) {
	switch (action.type) {
		case actionTypes.OPEN_REPORT_VIEWER_DIALOG:{
			return { 
				...state,
				open: true,
			}
		}
		case actionTypes.CLOSE_REPORT_VIEWER_DIALOG:{
			return { 
				...state,
				open: false,
			}
		}
		case actionTypes.QUICK_ADDED_SERVICE_PROVIDER: {
			return {
				...state,
				quickAddedServiceProvider: !state.quickAddedServiceProvider
			}
		}
	  default:
		return state
	}
}